import styled from 'styled-components';
import { Button } from '@gr-monorepo/common/ui';

export const Plate = styled.div`
  padding: 24px;
  border-radius: 20px;
  background: #fff;
  &:hover {
    box-shadow: 0px 12px 24px 0px rgba(57, 78, 127, 0.2);
  }
`;

export const Header = styled.div`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 34px;
  white-space: pre-line;
`;

export const Wrap = styled.div`
  padding: 24px 24px 32px;
  border-radius: 10px;
  background: #f4f5f6;
`;

export const Title = styled.div`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
`;

export const ButtonStyle = styled(Button)`
  padding: 11px 24px;
  width: 200px;
  height: 40px;
  border-radius: 8px;
  transition: background-color ease 0.3s;
  &:hover {
    opacity: 0.9;
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  align-items: center;
  border-bottom: #09152659 2px solid;
  padding-right: 30px;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #09152699;
`;

export const CellTitle = styled.div`
  padding: 22px 0;
`;

export const CellResult = styled.div`
  font-size: 30px;
  line-height: 40px;
  justify-content: center;
  text-align: end;
`;

export const CellHeader = styled(CellTitle)`
  foont-size: 14px;
  line-height: 20px;
  text-align: end;
  padding: 0;
`;

export const ButtonBlock = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  line-height: 19px;
`;
export const FieldFlexRow = styled.div`
  display: flex;
  align-items: center;
`;

export const PolicyLink = styled.a`
  font-weight: 700;
  line-height: 22px;
  color: #1cc67f;
  outline: none;
  &:active,
  &:focus,
  &:hover,
  &:visited {
    color: #1cc67f;
  }
`;

export const TitleForm = styled.div`
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  white-space: nowrap;
`;

export const WrapChart = styled.div``;

export const Name = styled.div`
  font-size: 14px;
  line-height: 20px;
`;

export const NameHeader = styled(Name)`
  width: 325px;
  color: rgba(9, 21, 38, 0.6);
  font-weight: 700;
`;
export const Persent = styled.div`
  flex: 1 0 auto;
  display: flex;
  margin-right: 42px;
`;
export const Progress = styled.div`
  height: 20px;
  min-width: 1px;
  background: linear-gradient(90deg, #5e81ff 0%, #cc78fa 99.78%);

  border-radius: 0 20px 1px 0;
  overflow: hidden;
`;

export const ProgressBlock = styled.div`
  width: 472px;
  height: 20px;
  background: linear-gradient(90deg, #5e81ff 0%, #cc78fa 99.78%);
`;
export const ProgressLabel = styled.div`
  line-height: 20px;
  margin-left: 4px;
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  width: 0px;
`;

export const RowChart = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: end;
`;

export const RowBoby = styled(RowChart)`
  margin-bottom: 16px;
}
`;
export const Hr = styled.div`
  background: rgba(9, 21, 38, 0.35);
  width: 100%;
  height: 1px;
`;

export const HeaderTitle = styled.div`
  width: 100%;
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
`;
export const WrapCell = styled.div`
  width: 325px;
  display: flex;
  gap: 8px;
  align-items: flex-start;
  color: rgba(9, 21, 38, 0.6);
  font-size: 14px;
  line-height: 20px;
  padding-right: 8px;
`;

export const ScrollBlock = styled.div`
  margin: 24px 0;
  max-height: 295px;
  overflow-y: scroll;

  /* Общая ширина/высота скроллбара */
  ::-webkit-scrollbar {
    width: 12px; /* Ширина вертикального скроллбара */
  }

  /* Цвет ползунка */
  ::-webkit-scrollbar-thumb {
    background-color: #ddc1ed;
    border-radius: 10px;
  }

  /* Цвет фона области скроллбара */
  ::-webkit-scrollbar-track {
    background-color: rgba(9, 21, 38, 0.07);
  }

  /* для Firefox Цвет ползунка и дорожки */
  scrollbar-color: #ddc1ed #09152612;
`;

export const InputFieldLabel = styled.span`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
`;

export const Text = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #091526d9;
`;

export const WrapLabel = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 8px;
  background-color: #f0deff;
  border-radius: 10px;
`;

export const ModalWrap = styled.div`
  width: 832px;
  padding: 24px 32px 32px 32px;
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0px 12px 24px rgba(57, 78, 127, 0.2);
  border-radius: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ContentModal = styled.div`
  padding: 24px;
  background-color: #09152612;
  border-radius: 8px;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: left;
  display: grid;
  gap: 16px;
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  max-width: 100%;
`;
